import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { withRouter } from 'react-router';

import Grid from '@material-ui/core/Grid';
import Link from 'components/CncUI/Link';
import Card from 'components/CncUI/Card';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import support from 'constants/config/support';
import SupportFooter from 'components/SupportFooter';

import LeftArrow from '@material-ui/icons/KeyboardArrowLeftRounded';

const useStyles = makeStyles(({ spacing, breakpoints, palette }) => ({
  contentBox: {
    margin: `56px auto`,
    padding: `${spacing(4)}px 118px 0`,
    [breakpoints.up('md')]: {
      width: 376,
    },
    [breakpoints.down('sm')]: {
      padding: `${spacing(4)}px 20px`,
    },
    '& .MuiLink-underlineHover:hover': {
      textDecoration: 'none',
    },
  },
  subtitle: {
    marginTop: 0,
    marginBottom: spacing(3),
  },
  linkContainer: {
    textAlign: 'center',
    margin: `${spacing(5)}px auto`,
  },
  link: {
    display: 'flex',
    textDecoration: 'none',
    justifyContent: 'center',
    alignContent: 'center',
  },

  iconContainer: {
    height: 20,
    width: 20,
    borderRadius: '50%',
    backgroundColor: palette.cncUI.default['-5'],
    marginRight: spacing(1),
  },
  icon: {
    padding: 2,
    fontSize: 16,
    color: palette.cncUI.white,
  },
  cardContent: {
    paddingTop: spacing(1),
    paddingBottom: spacing(1),
    '& p': {
      textAlign: 'center',
      margin: 0,
    },
  },
}));

const SUPPORT_INFO = support.helpDesk;

const Error = props => {
  const {
    support = SUPPORT_INFO,
    title,
    desc,
    isMobile,
    location: { pathname } = {},
  } = props;
  const classes = useStyles();
  const subtitle = desc ? (
    desc
  ) : (
    <>
      There was a problem with your registration.
      <br />
      Please contact {support?.title} for assistance.
    </>
  );

  const isRegister = pathname.startsWith('/register');

  return (
    <>
      <ContentBox id="Error" dense className={classes.contentBox}>
        <Grid
          container
          spacing={2}
          className={classes.wrapper}
          justifyContent="center"
        >
          <Grid item xs={12} sm={8} md={12}>
            <Typography variant="h3" id="Error-Title" align="center">
              {title || 'Something went wrong'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8} md={12}>
            <Typography
              id="Error-subtitle"
              align="center"
              className={classes.subtitle}
              variant="body2"
              size="short"
            >
              {subtitle}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={8} md={12}>
            <Card>
              <Card.Title align="center">{`Contact ${support?.title}`}</Card.Title>
              <Card.Content>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={3}
                  className={classes.cardContent}
                >
                  <Grid item>
                    <Typography variant="caption">Phone</Typography>
                    <Typography
                      variant="body1"
                      size="short"
                      className={classes.link}
                    >
                      <Link
                        className={clsx(classes.link)}
                        href={support?.phone2?.link || support?.phone?.link}
                      >
                        {support?.phone2?.display || support?.phone?.display}
                      </Link>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Email</Typography>
                    <Typography
                      variant="body1"
                      size="short"
                      className={classes.link}
                    >
                      <Link
                        className={clsx(classes.link)}
                        href={support?.email?.link}
                      >
                        {support?.email?.display}
                      </Link>
                    </Typography>
                  </Grid>
                </Grid>
              </Card.Content>
            </Card>
          </Grid>
          <Grid item xs={12} sm={8} md={12} className={classes.linkContainer}>
            <Link
              className={classes.withIcon}
              to="/login"
              id="Back-ToDashboardLink"
            >
              <Button
                id="UpdateProfile-BackButton"
                fullWidth
                tertiary
                href="/"
                startIcon={<LeftArrow />}
                className={classes.button}
              >
                Back to Dashboard
              </Button>
            </Link>
          </Grid>
        </Grid>
      </ContentBox>
      {isRegister && <SupportFooter isMobile={isMobile} showPrivacy={false} />}
    </>
  );
};

export default withRouter(Error);
